import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { MbMyaccountComponent } from './mb-myaccount/mb-myaccount.component'
import { MbMyaccountNavigationComponent } from './mb-myaccount-navigation/mb-myaccount-navigation.component'
import { MbMyaccountContactboxComponent } from './mb-myaccount-contactbox/mb-myaccount-contactbox.component'
import { RouterModule } from '@angular/router'
import { MbI18nModule } from '../translations/mb-i18n.module'
import { DirectiveModule } from '../shared/directive.module'
import { PageMetaResolver, provideConfig, provideDefaultConfig, UrlModule } from '@spartacus/core'
import { MbMyaccountNavBubbleComponent } from './mb-myaccount-navigation/mb-myaccount-nav-bubble/mb-myaccount-nav-bubble.component'
import { MbMyaccountTileComponent } from './mb-myaccount-tile/mb-myaccount-tile.component'
import { mbAccountRoutes, mbAccountRoutingConfig } from './config/mb-myaccount-routing-config'
import { MbMyaccountBackgroundComponent } from './mb-myaccount-background/mb-myaccount-background.component'
import { MbOrderHistoryComponent } from './mb-order-history/mb-order-history.component'
import { ListNavigationModule, MediaModule, ProductListItemContextSource } from '@spartacus/storefront'
import { MbMyaccountButtonComponent } from './mb-myaccount-button/mb-myaccount-button.component'
import { MbOrderDetailsEuComponent } from './mb-order-history/mb-order-details/mb-order-details-eu/mb-order-details-eu.component'
import {
  MbMyaccountMobileNavigationComponent
} from './components/mb-myaccount-navigation/mb-myaccount-mobile-navigation/mb-myaccount-mobile-navigation.component'
import { MbCartDetailsModule } from '../cart/components/mb-cart-details/mb-cart-details.module'
import { SharedModule } from '../shared/shared.module'
import { MbSubmitOrderModule } from '../cart/components/mb-submit-order/mb-submit-order.module'
import {
  MbOrderDetailsTotalsComponent
} from './mb-order-history/mb-order-details/mb-order-details-totals/mb-order-details-totals.component'
import { MbMyAddressesAdapter } from '../shared/adapters/mb-my-addresses.adapter'
import { MbOccMyaccountAddressbookAdapter } from './adapters/mb-occ-myaccount-addressbook.adapter'
import { MbAddressTileModule } from '../shared/components/mb-address-tile/mb-address-tile.module'
import {
  MbMyaccountAddressbookEuComponent
} from './components/mb-myaccount-addressbook/mb-myaccount-addressbook-eu/mb-myaccount-addressbook-eu.component'
import {
  MbMyaccountAddressbookUsComponent
} from './components/mb-myaccount-addressbook/mb-myaccount-addressbook-us/mb-myaccount-addressbook-us.component'
import { MbMyAccountWishListComponent } from './mb-my-account-wish-list/mb-my-account-wish-list.component'
import {
  MbMyAccountWishListItemComponent
} from './mb-my-account-wish-list/mb-myaccount-wish-list-item/mb-myaccount-wish-list-item.component'
import { MbAddToCartModule } from '../cart/components/mb-add-to-cart/mb-add-to-cart.module'
import { SafeHtmlModule } from '../cms/pipes/sanitize-html/safe-html.module'
import { MbMyaccountLogoutComponent } from './mb-myaccount/mb-myaccount-logout/mb-myaccount-logout.component'
import { MbLogoutAdapter } from '../shared/adapters/mb-logout.adapter'
import { MbOccLogoutAdapter } from '../shared/services/mb-logout/mb-occ-logout.adapter'
import { ContactBoxInCartComponent } from '../cms/components/contact-box/contact-box-in-cart/contact-box-in-cart.component'
import { MbMyaccountNoDataCardComponent } from './components/mb-myaccount-no-data-card/mb-myaccount-no-data-card.component'
import { MiltenyiMyAccountPageMetaResolver } from './services/miltenyi-myaccount-page-meta.resolver'
import {
  MbMyaccountAddressbookAuComponent
} from './components/mb-myaccount-addressbook/mb-myaccount-addressbook-au/mb-myaccount-addressbook-au.component'
import { MbOrderDetailsAuComponent } from './mb-order-history/mb-order-details/mb-order-details-au/mb-order-details-au.component'
import { MbOrderDetailsUsComponent } from './mb-order-history/mb-order-details/mb-order-details-us/mb-order-details-us.component'
import { MbOrderDetailsBaseComponent } from './mb-order-history/mb-order-details/mb-order-details-base.component'
import { ContactBoxInCartFeatureModule } from '../cms/components/contact-box/contact-box-in-cart/contact-box-in-cart-feature.module'
import { LinkModule } from '../cms/components/shared/link/link.module'

@NgModule({
  declarations: [
    MbMyaccountComponent,
    MbMyaccountNavigationComponent,
    MbMyaccountContactboxComponent,
    MbMyaccountNavBubbleComponent,
    MbMyaccountTileComponent,
    MbMyaccountBackgroundComponent,
    MbMyaccountAddressbookEuComponent,
    MbMyaccountAddressbookUsComponent,
    MbMyaccountMobileNavigationComponent,
    MbOrderHistoryComponent,
    MbMyaccountButtonComponent,
    MbOrderDetailsEuComponent,
    MbOrderDetailsTotalsComponent,
    MbMyAccountWishListComponent,
    MbMyAccountWishListItemComponent,
    MbMyaccountLogoutComponent,
    MbMyaccountNoDataCardComponent,
    MbMyaccountAddressbookAuComponent,
    MbOrderDetailsAuComponent,
    MbOrderDetailsUsComponent,
    MbOrderDetailsBaseComponent
  ],
  imports: [
    CommonModule,
    RouterModule.forChild(mbAccountRoutes),
    MbI18nModule,
    DirectiveModule,
    UrlModule,
    ListNavigationModule,
    MbCartDetailsModule,
    SharedModule,
    MbSubmitOrderModule,
    MbAddressTileModule,
    MbAddToCartModule,
    ContactBoxInCartFeatureModule,
    SafeHtmlModule,
    MediaModule,
    LinkModule
  ],
  providers: [
    ProductListItemContextSource,
    provideDefaultConfig(mbAccountRoutingConfig),
    provideConfig({
      cmsComponents: {
        MiltenyiAccountDashboardComponent: {
          component: MbMyaccountComponent,
        },
        WishListComponent: {
          component: MbMyAccountWishListComponent,
        },
        MiltenyiAccountOrderHistoryComponent: {
          component: MbOrderHistoryComponent,
        },
        MiltenyiAccountOrderDetailsComponent: {
          component: MbOrderDetailsEuComponent,
        },
        MiltenyiAccountAUOrderDetailsComponent: {
          component: MbOrderDetailsAuComponent
        },
        MiltenyiAccountUSOrderDetailsComponent: {
          component: MbOrderDetailsUsComponent
        },
        MiltenyiAccountOrderDetailsSummaryComponent: {
          component: MbOrderDetailsTotalsComponent,
        },
        MiltenyiAddressBookEUShippingAddressNoStateComponent: {
          component: MbMyaccountAddressbookEuComponent,
        },
        MiltenyiAddressBookUSShippingAddressComponent: {
          component: MbMyaccountAddressbookUsComponent,
        },
        MiltenyiAddressBookAUComponent: {
          component: MbMyaccountAddressbookAuComponent,
        },
        MyAccountContactBoxComponent: {
          component: ContactBoxInCartComponent
        },
        ContactBoxComponent: {
          component: ContactBoxInCartComponent
        }
      },
    }),
    {
      provide: MbMyAddressesAdapter,
      useExisting: MbOccMyaccountAddressbookAdapter,
    },
    {
      provide: MbLogoutAdapter,
      useExisting: MbOccLogoutAdapter,
    },
    {
      provide: PageMetaResolver,
      useExisting: MiltenyiMyAccountPageMetaResolver,
      multi: true,
    }
  ]
})
export class MyAccountModule {}

export interface ContactBoxMyAccountContactData {
  ordersEmail: string;
  ordersPhone: string;
}

export interface MbMobileNavigationsModel {
  text: string;
  link: string;
  icon: string;
  activeIcon: string;
  isExternal?: boolean;
}
